import { ProductResponse } from 'lib/services/models/content-response';
import useDictionary from 'lib/hooks/useDictionary';
import { SvgIcon } from 'components/helpers/SvgIcon';
import { normalizeSymbols } from 'lib/utils/normalize-symbols';

import styles from './ProductConsumerStatements.module.scss';

export interface ProductConsumerStatementsProps {
  product?: ProductResponse;
  hideConsumerStatements?: boolean;
}

export function ProductConsumerStatements({
  product,
  hideConsumerStatements,
}: ProductConsumerStatementsProps) {
  // Translations
  const { getDictionaryValue } = useDictionary();

  const consumerStatements = hideConsumerStatements ? undefined : product?.ConsumerStatement;
  if (!consumerStatements?.length) {
    return <></>;
  }

  return (
    <div>
      <div>
        {consumerStatements && consumerStatements.length > 0 ? (
          <div>
            <h2 className={styles.productConsumerStatementsHeading}>
              {getDictionaryValue(
                'Components.Product.ProductConsumerStatements.ProductConsumerStatementsHeadline'
              ) || 'Consumer statements'}
            </h2>
            <ul>
              {consumerStatements.map((statement, index) => (
                <li key={index} className={styles.productConsumerStatementsItem}>
                  <SvgIcon
                    icon="checkmark-circled"
                    className={styles.productConsumerStatementsIcon}
                    size="md"
                  />
                  <span className={styles.productConsumerStatementsText}>
                    {normalizeSymbols(statement)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
}
